var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideocall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.300781 4.2C0.300781 3.35131 0.637923 2.53737 1.23804 1.93726C1.83816 1.33714 2.65209 1 3.50078 1H15.5008C16.2769 0.999909 17.0267 1.28191 17.6103 1.79348C18.194 2.30506 18.5719 3.01134 18.6736 3.7808L23.6496 1.5696C23.8931 1.46107 24.16 1.41514 24.4258 1.43598C24.6916 1.45681 24.948 1.54375 25.1717 1.6889C25.3954 1.83405 25.5793 2.03279 25.7066 2.26708C25.8339 2.50136 25.9007 2.76375 25.9008 3.0304V14.9696C25.9005 15.236 25.8338 15.4982 25.7065 15.7323C25.5793 15.9664 25.3956 16.165 25.1722 16.3101C24.9487 16.4552 24.6925 16.5422 24.4269 16.5632C24.1613 16.5842 23.8947 16.5386 23.6512 16.4304L18.6736 14.2192C18.5719 14.9887 18.194 15.6949 17.6103 16.2065C17.0267 16.7181 16.2769 17.0001 15.5008 17H3.50078C2.65209 17 1.83816 16.6629 1.23804 16.0627C0.637923 15.4626 0.300781 14.6487 0.300781 13.8V4.2ZM18.7008 12.48L24.3008 14.9696V3.0304L18.7008 5.52V12.48ZM3.50078 2.6C3.07643 2.6 2.66947 2.76857 2.36941 3.06863C2.06935 3.36869 1.90078 3.77565 1.90078 4.2V13.8C1.90078 14.2243 2.06935 14.6313 2.36941 14.9314C2.66947 15.2314 3.07643 15.4 3.50078 15.4H15.5008C15.9251 15.4 16.3321 15.2314 16.6322 14.9314C16.9322 14.6313 17.1008 14.2243 17.1008 13.8V4.2C17.1008 3.77565 16.9322 3.36869 16.6322 3.06863C16.3321 2.76857 15.9251 2.6 15.5008 2.6H3.50078Z",
    fill: "#979797",
    stroke: "#979797",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocall);
export default __webpack_public_path__ + "static/media/videocall.351d0515259f4331a1722e4f47987991.svg";
export { ForwardRef as ReactComponent };